import { formatAbbrev } from '@/features/dashboard/format/format'
import type { ChartPalette } from './chartTheme'
import styles from '../ExpandedBarChart.module.css'

const TRIANGLE_UP =
  'M17.8892 15.7522C18.2722 16.4188 17.7909 17.2503 17.0221 17.2503H6.97756C6.20872 17.2503 5.72748 16.4188 6.11045 15.7522L11.1327 7.00969C11.5171 6.34052 12.4825 6.34052 12.8669 7.00969L17.8892 15.7522Z'
const TRIANGLE_DOWN =
  'M17.8892 8.24812C18.2722 7.58146 17.7909 6.75 17.0221 6.75H6.97756C6.20872 6.75 5.72748 7.58146 6.11045 8.24813L11.1327 16.9906C11.5171 17.6598 12.4825 17.6598 12.8669 16.9906L17.8892 8.24812Z'

const escapeHtml = (text: string) =>
  text.replace(
    /[&<>"']/g,
    char =>
      ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[
        char
      ] ?? char
  )

type TooltipContent = {
  label: string
  value: number
  previous: number | null
  unit: string | null | undefined
  palette: ChartPalette
}

export const tooltipHtml = ({
  label,
  value,
  previous,
  unit,
  palette,
}: TooltipContent) => {
  const change =
    previous === null || previous === 0
      ? ''
      : (() => {
          const up = value >= previous
          const pct = Math.abs(((value - previous) / previous) * 100)
          return (
            `<div class="${styles.tooltipChange}" style="color:${up ? palette.positive : palette.negative}">` +
            `<svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor" aria-hidden="true"><path d="${up ? TRIANGLE_UP : TRIANGLE_DOWN}"/></svg>` +
            `<span>${pct.toFixed(1)}%</span></div>`
          )
        })()
  return (
    `<div class="${styles.tooltip}" style="background:${palette.card};border-color:${palette.crosshair};color:${palette.text}">` +
    `<span class="${styles.tooltipLabel}" style="color:${palette.textAlt}">${escapeHtml(label)}</span>` +
    `<span class="${styles.tooltipValue}">${escapeHtml(formatAbbrev(value, unit, 2))}</span>` +
    `${change}</div>`
  )
}
